var React = require('react');

function FooterBlob (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M143.622 0.00330875C206.71 0.360159 254.131 31.9238 272.514 68.7436C289.771 103.311 272.179 140.769 224.675 162.352C175.361 184.759 107.923 188.087 57.9459 166.234C7.01752 143.966 -11.6362 103.708 7.15846 67.2427C26.5487 29.6213 78.9807 -0.362327 143.622 0.00330875Z","fill":"white"}));
}

FooterBlob.defaultProps = {"width":"279","height":"181","viewBox":"0 0 279 181","fill":"none"};

module.exports = FooterBlob;

FooterBlob.default = FooterBlob;
